var _defs, _path, _g, _g2, _g3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTranscriptionHeaderModal = function SvgTranscriptionHeaderModal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_6336",
    "data-name": "Grupo 6336",
    width: 536,
    height: 140,
    viewBox: "0 0 536 140",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "transcription-header-modal-linear-gradient",
    x1: 0.008,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdad3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9f8ba"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transcription-header-modal-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2315",
    "data-name": "Ret\\xE2ngulo 2315",
    width: 294,
    height: 87,
    transform: "translate(-0.4 0.064)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "transcription-header-modal-clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2316",
    "data-name": "Ret\\xE2ngulo 2316",
    width: 53.336,
    height: 64.191,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8598",
    "data-name": "Caminho 8598",
    d: "M506,0H30C13.431,0,0,12.054,0,26.923V140H536V26.923C536,12.054,522.569,0,506,0Z",
    fill: "url(#transcription-header-modal-linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6335",
    "data-name": "Grupo 6335",
    transform: "translate(121.4 26.936)",
    opacity: 0.6,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6330",
    "data-name": "Grupo 6330",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6329",
    "data-name": "Grupo 6329",
    clipPath: "url(#transcription-header-modal-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_52",
    "data-name": "Subtra\\xE7\\xE3o 52",
    d: "M19793.691,16945.643a3.117,3.117,0,0,1-2.207-5.318l4.176-4.162h-22.568a3.111,3.111,0,0,1,0-6.223h22.584l-4.191-4.186a3.106,3.106,0,0,1-.91-2.2,3.067,3.067,0,0,1,.91-2.187,3.122,3.122,0,0,1,4.4-.01l9.3,9.291a3.1,3.1,0,0,1,.9,2.342v.109a3.092,3.092,0,0,1-.9,2.342l-9.3,9.291A3.077,3.077,0,0,1,19793.691,16945.643Z",
    transform: "translate(-19619.926 -16889.48)",
    fill: "#4b4b4b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8573",
    "data-name": "Caminho 8573",
    d: "M13.83,0h91.279a13.83,13.83,0,0,1,13.83,13.83V73.3a13.83,13.83,0,0,1-13.83,13.83H13.83A13.83,13.83,0,0,1,0,73.3V13.83A13.83,13.83,0,0,1,13.83,0",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8574",
    "data-name": "Caminho 8574",
    d: "M105.109,87.13H13.83A13.846,13.846,0,0,1,0,73.3V13.83A13.846,13.846,0,0,1,13.83,0h91.279a13.846,13.846,0,0,1,13.83,13.83V73.3a13.846,13.846,0,0,1-13.83,13.83M13.83,4.149A9.692,9.692,0,0,0,4.149,13.83V73.3a9.692,9.692,0,0,0,9.681,9.681h91.279A9.692,9.692,0,0,0,114.79,73.3V13.83a9.692,9.692,0,0,0-9.681-9.681Z",
    transform: "translate(0 -0.001)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8575",
    "data-name": "Caminho 8575",
    d: "M11.458,8A3.458,3.458,0,1,1,8,11.458,3.457,3.457,0,0,1,11.458,8",
    transform: "translate(3.064 3.063)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8576",
    "data-name": "Caminho 8576",
    d: "M18.458,8A3.458,3.458,0,1,1,15,11.458,3.457,3.457,0,0,1,18.458,8",
    transform: "translate(5.745 3.063)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8577",
    "data-name": "Caminho 8577",
    d: "M25.458,8A3.458,3.458,0,1,1,22,11.458,3.457,3.457,0,0,1,25.458,8",
    transform: "translate(8.426 3.063)",
    fill: "#4b4b4b"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6332",
    "data-name": "Grupo 6332",
    transform: "translate(32.412 20.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6331",
    "data-name": "Grupo 6331",
    clipPath: "url(#transcription-header-modal-clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8578",
    "data-name": "Caminho 8578",
    d: "M47.108,15.086h0a15.851,15.851,0,1,0,11.211,4.64,15.853,15.853,0,0,0-11.211-4.64m0,27.327a11.479,11.479,0,0,1-.173-22.944h.173a11.479,11.479,0,0,1,0,22.958",
    transform: "translate(-20.439 -15.087)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8579",
    "data-name": "Caminho 8579",
    d: "M25.624,69.492A2.193,2.193,0,0,0,27.812,67.3,22.293,22.293,0,0,1,72.4,66.952c0,.118,0,.234,0,.351a2.188,2.188,0,1,0,4.376,0,26.668,26.668,0,1,0-53.336,0,2.193,2.193,0,0,0,2.188,2.188",
    transform: "translate(-23.436 -5.301)",
    fill: "#4b4b4b"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6334",
    "data-name": "Grupo 6334",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6333",
    "data-name": "Grupo 6333",
    clipPath: "url(#transcription-header-modal-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8580",
    "data-name": "Caminho 8580",
    d: "M172.83,0H218.47A13.83,13.83,0,0,1,232.3,13.83V73.3a13.83,13.83,0,0,1-13.83,13.83H172.83A13.83,13.83,0,0,1,159,73.3V13.83A13.83,13.83,0,0,1,172.83,0",
    transform: "translate(60.899 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8581",
    "data-name": "Caminho 8581",
    d: "M218.471,87.13H172.831A13.846,13.846,0,0,1,159,73.3V13.83A13.846,13.846,0,0,1,172.831,0h45.639A13.847,13.847,0,0,1,232.3,13.83V73.3a13.847,13.847,0,0,1-13.83,13.83M172.831,4.149a9.693,9.693,0,0,0-9.681,9.681V73.3a9.693,9.693,0,0,0,9.681,9.681h45.639a9.694,9.694,0,0,0,9.681-9.681V13.83a9.694,9.694,0,0,0-9.681-9.681Z",
    transform: "translate(60.9 -0.001)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_53",
    "data-name": "Subtra\\xE7\\xE3o 53",
    d: "M19776.205,16935.6h0a8.3,8.3,0,0,1,0-16.537v16.537Zm-1.379-12.771v0c-1.785.193-3.182,2.17-3.182,4.5s1.4,4.3,3.182,4.492v-8.99Z",
    transform: "translate(-19554.922 -16902.438)",
    fill: "#4b4b4b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8585",
    "data-name": "Caminho 8585",
    d: "M160.729,12.25h8.99a1.729,1.729,0,0,1,0,3.458h-8.99a1.729,1.729,0,0,1,0-3.458",
    transform: "translate(60.899 4.691)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_54",
    "data-name": "Subtra\\xE7\\xE3o 54",
    d: "M19776.205,16935.6h0a8.3,8.3,0,0,1,0-16.537v16.537Zm-1.379-12.771v0c-1.785.193-3.182,2.17-3.182,4.5s1.4,4.3,3.182,4.492v-8.99Z",
    transform: "translate(-19554.922 -16881.691)",
    fill: "#4b4b4b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8589",
    "data-name": "Caminho 8589",
    d: "M160.729,27.25h8.99a1.729,1.729,0,0,1,0,3.458h-8.99a1.729,1.729,0,0,1,0-3.458",
    transform: "translate(60.899 10.436)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_55",
    "data-name": "Subtra\\xE7\\xE3o 55",
    d: "M19776.205,16935.6h0a8.3,8.3,0,0,1,0-16.537v16.537Zm-1.379-12.777v0c-1.785.2-3.182,2.178-3.182,4.5s1.4,4.3,3.182,4.492v-9Z",
    transform: "translate(-19554.922 -16860.945)",
    fill: "#4b4b4b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8593",
    "data-name": "Caminho 8593",
    d: "M160.729,42.25h8.99a1.729,1.729,0,0,1,0,3.458h-8.99a1.729,1.729,0,0,1,0-3.458",
    transform: "translate(60.899 16.182)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8594",
    "data-name": "Caminho 8594",
    d: "M175.729,12.25H211a1.729,1.729,0,0,1,0,3.458H175.729a1.729,1.729,0,1,1,0-3.458",
    transform: "translate(66.645 4.691)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8595",
    "data-name": "Caminho 8595",
    d: "M175.729,18.25H211a1.729,1.729,0,0,1,0,3.458H175.729a1.729,1.729,0,1,1,0-3.458",
    transform: "translate(66.645 6.989)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8596",
    "data-name": "Caminho 8596",
    d: "M175.729,24.25H211a1.729,1.729,0,0,1,0,3.458H175.729a1.729,1.729,0,1,1,0-3.458",
    transform: "translate(66.645 9.287)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8597",
    "data-name": "Caminho 8597",
    d: "M175.729,30.25H194.4a1.729,1.729,0,1,1,0,3.458H175.729a1.729,1.729,0,1,1,0-3.458",
    transform: "translate(66.645 11.586)",
    fill: "#4b4b4b"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTranscriptionHeaderModal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transcription-header-modal.fc8b3161.svg";
export { ForwardRef as ReactComponent };